export const testimonials = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba',
    role: 'Profe de E. Funcional',
    text: 'Organicé todo el año en una tarde. El sistema de benchmarks me ahorra horas cada semana. Nunca más llego al lunes sin saber qué dar.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Profe de Entrenamiento Funcional',
    text: 'El bloque de potencia por fin tiene sentido. Los alumnos ven su progreso semana a semana y no se van más.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Profe de E. Funcional',
    text: 'Mis clases de resistencia por fin enganchan. El Tomo 5 vale cada peso. Nunca más improviso un AMRAP.',
  },
]

export const moreTestimonials = [
  {
    initials: 'CR',
    name: 'Cecilia Ruiz',
    age: 34,
    location: 'Mendoza',
    role: 'Profe de E. Funcional · 8 años de experiencia',
    text: 'Soy profe de E. Funcional desde 2017 y siempre tuve el mismo problema: los domingos los perdía buscando rutinas, armando planillas en Excel y al final no me quedaba tiempo para mí. Compré el Combo Completo en septiembre y en una sola tarde dejé organizado TODO el año. Lo más increíble es que el Bono 4 (101 reemplazos) me salva la vida cuando doy clases en la plaza. Mis alumnos de plaza tienen ahora la misma calidad de clase que los de gimnasio. Recuperé mis domingos. Eso no tiene precio.',
  },
  {
    initials: 'RM',
    name: 'Roberto Méndez',
    age: 41,
    location: 'Buenos Aires',
    role: 'Profe + Dueño de Box · 12 años en la profesión',
    text: 'Tengo un box en Capital y manejo 6 grupos diferentes. Antes tardaba 4 horas cada domingo planificando la semana de los 6 grupos. Era inviable. Con el Combo + Método Empresario ahora abro el Tomo del mes, leo la clase del día, ajusto cargas y listo. Pero lo que realmente cambió mi negocio fue el Método Profe Empresario: el modelo de suscripción mensual lo implementé en 30 días y mi facturación se estabilizó. Ya no tengo meses flacos. Pasé de cobrar por clase a cobrar por mes. La diferencia es brutal.',
  },
  {
    initials: 'SC',
    name: 'Sofía Cabrera',
    age: 28,
    location: 'La Plata',
    role: 'Profe de E. Funcional · 4 años de experiencia',
    text: 'Cuando empecé como profe me sentía perdida. No tenía estructura, copiaba rutinas de Instagram que no funcionaban con mi grupo real. Sentía que estaba estafando a mis alumnos. El Tomo 1 me ordenó desde la base. Mis alumnos terminaron los primeros 2 meses con TESTS MEDIBLES — eso nunca lo había logrado antes. Por primera vez puedo mostrarles a mis alumnos su progreso con números reales, no con sensaciones. Eso me dio una autoridad que no tenía. Ahora soy YO la que pone los precios.',
  },
  {
    initials: 'PA',
    name: 'Pablo Acosta',
    age: 38,
    location: 'Neuquén',
    role: 'Profe de E. Funcional · 10 años en gimnasios',
    text: 'Lo que más me cambió fue el Banco de Cierres de Clase (Bono 5). Yo cerraba las clases con un "bueno chicos, nos vemos mañana" y nada más. Después de implementar los cierres del bono, la retención de mi grupo subió notablemente — de 18 fijos a 31 en 4 meses. Los alumnos se van con una sensación de logro y al día siguiente vuelven con más ganas. Ese solo bono ya justifica el combo completo. Pero además los Tomos son una bestia. El sistema progresivo de 12 meses está pensado para que el alumno NO se aburra.',
  },
  {
    initials: 'VM',
    name: 'Verónica Maldonado',
    age: 45,
    location: 'Rosario',
    role: 'Profe de E. Funcional · Especialista en adultos',
    text: 'Tengo 45 años y trabajo principalmente con grupos de adultos de 50+. Pensé que un sistema "funcional" no me iba a servir porque suelen ser muy intensos. Me equivoqué. Las progresiones y regresiones de cada Tomo me permiten adaptar TODO. El Tomo 1 fue oro puro para mi grupo de adaptación. Y los protocolos de lumbar y rodilla del Método Empresario me dejaron tranquila para entrenar a alumnos que antes derivaba a kinesio. Hoy tengo lista de espera. Esto está pensado por alguien que SÍ da clases reales.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Adaptación Funcional',
    months: 'Meses 1-2',
    content:
      'Base técnica, 7 patrones funcionales, movilidad, activación, tests iniciales',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Fuerza Metabólica',
    months: 'Meses 3-4',
    content:
      'Carga progresiva, superseries, clusters, 5RM, metcons cronometrados',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Potencia y CORE',
    months: 'Meses 5-6',
    content:
      'CAT, contraste de carga, KB Swing, Box Jump, complejo de potencia, CORE tridimensional',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Hipertrofia Funcional',
    months: 'Meses 7-8',
    content: 'TUT, Rest-Pause, Myo-Reps, Drop Sets, excéntrico pesado',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Resistencia de Élite',
    months: 'Meses 9-10',
    content:
      'Threshold Training, HIIT funcional, Chipper, AMRAP largo, ondas de intensidad',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Peak Performance & Recuperación',
    months: 'Meses 11-12',
    content:
      'Periodización ondulatoria, tapering, re-test total del año, cierre y planificación 2026',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '🗺️',
    name: 'Mapa Anual de Clases Cero Estrés',
    desc: 'Calendario anual listo en 10 minutos. Ordena los 6 tomos por mes, objetivo y progresión.',
    value: '$8.000',
  },
  {
    id: '02',
    icon: '🎤',
    name: '52 Aperturas de Clase que te Hacen Quedar como Pro',
    desc: 'Scripts listos para empezar cualquier clase con autoridad desde el minuto cero.',
    value: '$10.000',
  },
  {
    id: '03',
    icon: '✅',
    name: 'Checklist Express Pre-Clase y Post-Clase',
    desc: 'Entrá con todo bajo control y salí sin olvidar nada importante.',
    value: '$9.000',
  },
  {
    id: '04',
    icon: '🔄',
    name: '101 Reemplazos Inteligentes de Ejercicios',
    desc: 'Si falta material, espacio o el grupo cambia, resolvés en segundos.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '🎯',
    name: 'Banco de Cierres de Clase y Frases de Retención',
    desc: 'Terminá cada clase con impacto real para que el alumno quiera volver.',
    value: '$9.000',
  },
  {
    id: '06',
    icon: '🖨️',
    name: 'Kit de Impresión Rápida para Llevar a Clase',
    desc: 'Fichas, tarjetas y planillas listas para imprimir y trabajar sin el celular.',
    value: '$9.000',
  },
]

export const faqs = [
  {
    q: '¿Sirve para todos los contextos (plaza, gym, box)?',
    a: 'Sí. El sistema está diseñado para funcionar con material estándar (kettlebells, mancuernas, bandas). El Bono 4 tiene 101 reemplazos para cuando falta material o cambia el espacio.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después del pago recibís un email con el enlace de descarga en menos de 5 minutos. Podés descargarlo en cualquier dispositivo e imprimirlo si querés.',
  },
  {
    q: '¿Qué lo diferencia de otros planes de entrenamiento que encuentro online?',
    a: 'Los planes online son para alumnos. Este sistema es para el profe. Cada clase viene estructurada con bloques, cues técnicos, progresiones, regresiones, tiempos y métodos listos para ejecutar sin pensar. No es un banco de ejercicios. Es un sistema anual de 240 clases.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, devolución completa, sin preguntas. Escribís a compradigitalyaa@gmail.com y se resuelve el mismo día.',
  },
  {
    q: '¿Funciona si soy profe principiante?',
    a: 'Sí. El Tomo 1 arranca desde la base técnica. Cada clase tiene explicaciones del método y cues para el profe, no solo para el alumno. Si recién empezás, este sistema te da la estructura que te llevaría años construir solo.',
  },
  {
    q: '¿Qué pasa si mis alumnos tienen lesiones?',
    a: 'El Combo + Método Empresario incluye protocolos de adaptación para lumbar, rodilla y hombro. Si elegís solo el Combo Completo, el Bono 4 tiene reemplazos por nivel y contexto para adaptar cualquier ejercicio.',
  },
  {
    q: '¿Puedo usarlo si doy clases personalizadas (one to one)?',
    a: 'Sí. Aunque el sistema está optimizado para grupos, cada clase tiene progresiones y regresiones que te permiten adaptarla a un alumno individual. Muchos profes lo usan como base para sus PT y luego personalizan los pesos y volúmenes.',
  },
  {
    q: '¿Cuánto tiempo tarda en bajar el material?',
    a: 'El acceso completo se entrega en menos de 5 minutos después del pago. Recibís un email automático con todos los PDFs (los 6 Tomos + los 6 Bonos). Podés bajarlo a tu celular, tablet, computadora o imprimirlo todas las veces que quieras.',
  },
  {
    q: '¿Hay diferencia entre el Combo Completo y el Combo + Negocio?',
    a: 'El Combo Completo te resuelve el LADO TÉCNICO: 240 clases, progresiones, benchmarks, tomos, bonos. El Combo + Método Profe Empresario suma el LADO NEGOCIO: pricing para Argentina, modelo de suscripción mensual, scripts de WhatsApp, sistema de Instagram y protocolos clínicos. Si querés además construir un negocio rentable, andá por el Combo + Negocio.',
  },
  {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Mercado Pago (todas las tarjetas, débito y crédito), transferencia bancaria y efectivo en Rapipago / Pago Fácil. Podés pagar en hasta 12 cuotas con tarjeta. La compra es 100% segura mediante el checkout encriptado de Mercado Pago.',
  },
]

export const purchaseNotifications = [
  { name: 'Mariela G.', city: 'Córdoba', plan: 'Combo Completo' },
  { name: 'Roberto M.', city: 'Buenos Aires', plan: 'Combo + Negocio' },
  { name: 'Laura P.', city: 'Rosario', plan: 'Combo Completo' },
  { name: 'Sofía C.', city: 'La Plata', plan: 'Combo + Negocio' },
  { name: 'Pablo A.', city: 'Neuquén', plan: 'Combo Completo' },
  { name: 'Cecilia R.', city: 'Mendoza', plan: 'Combo + Negocio' },
  { name: 'Verónica M.', city: 'Salta', plan: 'Combo Completo' },
  { name: 'Diego F.', city: 'Tucumán', plan: 'Combo + Negocio' },
  { name: 'Andrea L.', city: 'Mar del Plata', plan: 'Combo Completo' },
  { name: 'Martín S.', city: 'Bahía Blanca', plan: 'Combo + Negocio' },
  { name: 'Gabriela T.', city: 'Santa Fe', plan: 'Combo Completo' },
  { name: 'Federico R.', city: 'Corrientes', plan: 'Combo + Negocio' },
]
